module.exports = __webpack_public_path__ + "img/中华儿慈会@2x.d486ea16.png";